import * as React from 'react';

export const iconPen = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M11.3575 3.64189L16.3582 8.64267L5.49925 19.5017L1.04066 19.9938C0.443784 20.0599 -0.0605133 19.5552 0.00589298 18.9583L0.501987 14.4966L11.3575 3.64189V3.64189ZM19.4512 2.89736L17.1032 0.549316C16.3707 -0.183105 15.1828 -0.183105 14.4504 0.549316L12.2414 2.7583L17.2422 7.75908L19.4512 5.55009C20.1836 4.81728 20.1836 3.62978 19.4512 2.89736V2.89736Z" />
    </svg>
  );
};
